import logError from "./errorLogger";
import { AuthService as auth } from "../firebase/config.js";

async function request(url, method, body, context, withUserToken = false) {
  let headers = new Headers();
  try {
    headers.append('x-api-key', process.env.VUE_APP_FRIENDLIER_API_KEY ?? '');
    if (withUserToken) {
      headers.append('x-user-token', await auth.currentUser?.getIdToken(true) ?? '');
    }
  } catch (err) {
    logError(`Request.${context}: Failed to setup headers. ${err.toString()}`);
  }
  
  let response, responseBody;
  try {
    let options = {
      method: method,
      headers: headers,
    }

    if (body) {
      options['body'] = JSON.stringify(body);
    }

    response = await fetch(url, options);
    responseBody = await response.json();
  } catch (err) {
    logError(`Request.${context}: Failed to request. ${err.toString()}`);
    throw new Error(`Failed to request. ${context}. ${err.toString()}`);
  }

  const throwWithResponse = (message) => {
    const err = new Error(message);
    err.response = responseBody;
    throw err;
  };

  if (response.status == 400)
    throwWithResponse("Bad Request")
  if (response.status == 401)
    throwWithResponse("Unauthorized")
  if (response.status == 403)
    throwWithResponse("Access Denied")
  if (response.status == 404)
    throwWithResponse("Endpoint not found")
  if (response.status == 500) {
    throwWithResponse(`Server Error ${response.status} - ${responseBody["message"]}`);
  }
  if (responseBody['error']) {
    throwWithResponse(responseBody['message']);
  }
  return responseBody
}

export default request;